export default __webpack_public_path__ + "static/media/icons8-linkedin.2ef8fe55.svg";